export default "__VITE_ASSET__CEGDXLnb__"